import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stripe-guide-modal" }
const _hoisted_2 = { class: "modal-bar" }

import { useModalStore } from "@/shared/stores/modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'StripeCredentialsGuideModal',
  setup(__props) {

const modal = useModalStore();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "modal-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-title" }, "Stripe setup guide", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, { class: "body py-6" }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "section" }, [
          _createElementVNode("div", { class: "section-title" }, "Where to find your keys"),
          _createElementVNode("ol", { class: "list" }, [
            _createElementVNode("li", null, "Open your Stripe Dashboard."),
            _createElementVNode("li", null, [
              _createTextVNode("Go to "),
              _createElementVNode("strong", null, "Developers"),
              _createTextVNode(" → "),
              _createElementVNode("strong", null, "API keys"),
              _createTextVNode(".")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode("Copy your "),
              _createElementVNode("strong", null, "Publishable key"),
              _createTextVNode(" and "),
              _createElementVNode("strong", null, "Secret key"),
              _createTextVNode(".")
            ])
          ])
        ], -1),
        _createElementVNode("div", { class: "section" }, [
          _createElementVNode("div", { class: "section-title" }, "Webhook signing secret"),
          _createElementVNode("ol", { class: "list" }, [
            _createElementVNode("li", null, [
              _createTextVNode("In Stripe Dashboard, go to "),
              _createElementVNode("strong", null, "Developers"),
              _createTextVNode(" → "),
              _createElementVNode("strong", null, "Webhooks"),
              _createTextVNode(".")
            ]),
            _createElementVNode("li", null, "Select your endpoint (or create one)."),
            _createElementVNode("li", null, [
              _createTextVNode("Reveal and copy the "),
              _createElementVNode("strong", null, "Signing secret"),
              _createTextVNode(".")
            ])
          ]),
          _createElementVNode("p", { class: "note" }, " If you already have a webhook secret saved, you can see it in the credentials step (read-only). ")
        ], -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})